export default function(Mousetrap) {
    let _stopCallback = Mousetrap.prototype.stopCallback

    Mousetrap.prototype.stopCallback = function(e, element, combo) {
        let self = this

        const rx = /INPUT|TEXTAREA|SELECT/i
        const rxType = /checkbox|radio|submit/i

        let shouldStop = _stopCallback.call(self, e, element, combo) 
            && !(!rx.test(element.tagName) || rxType.test(element.type) || element.disabled || element.readOnly)

        return shouldStop
    }

    Mousetrap.init()
    
    return Mousetrap
}